import { Spin, Tooltip } from "antd";
import { ITooltipTextProps } from "./TooltipText.props";
import cn from "classnames";
import styles from "./TooltipText.module.scss";
import { LoadingOutlined } from "@ant-design/icons";

export default function TooltipText({ ...props }: ITooltipTextProps) {
  const { text, open, className, children, placement, ...rest } = props;
  return (
    <Tooltip
      open={open}
      trigger={"hover"}
      placement={placement}
      title={
        props.loading ? (
          <Spin
            indicator={<LoadingOutlined spin style={{ color: "white" }} />}
            size='small'
          />
        ) : (
          <p className={cn(styles.text, className)}>{text}</p>
        )
      }
      {...rest}
    >
      {children}
    </Tooltip>
  );
}
